export default {
    namespaced: true,
    state: {
        userMsg: '', //user信息
        searchdata: { //搜索信息
            data: []
        },
        selectfriend: {
            wechatContactinfo: {
                friendid: '',
                wechatid: ''
            }, //当前聊天好友信息
            wechatMessage: {
                lastmsgid: 0,
                data: []
            } //当前好友聊天记录信息
        },
        chatdata: {
            records: [],
            total:0
        }, //会话列表
        frienddata: {}, //好友列表
        chatstate: true, //是否聊天状态 否=》查看记录状态
        socketstate: false, //websocket是否连接
        msguuid: '', //消息uuid
        listwidth:'',//好友列表会话列表宽度
        documentary:false,//跟单侧边
        cansend: 1, // 是否可以在线发送消息
        documentarywidth:'',//好友列表会话列表宽度
        documentarybutton: false,//是否显示展示收起按钮
        taleSkillGrounp:'', //话术库点中单条
        reddata: {}, // 红包
        teamarr: [], //分组数据
        activeTeam: {
            type:0,
            activeindex:0,
            id: ''
        },// 当前微信分组
        rightbtn:0,//右键关闭随机数
    },
    mutations: {
        CLOSERIGHT(state, payload){
            console.log(payload)
            state.rightbtn = payload
        },
        SETTEAMLIST(state, payload){
            state.teamarr = payload
        },
        SETTEAM(state, payload){
            state.activeTeam = payload
        },
        SETRED(state, payload){
            state.reddata = payload
        },
        SETCANSEND(state, payload){
            state.cansend = payload
        },
        SETDOCBTN(state, payload){
            state.documentarybutton = payload
        },
        SETDOCWIDTH(state, payload){
            //改变抽屉状态
            state.documentarywidth = payload
        },
        SETDOC(state, payload){
            //改变按钮状态
            state.documentary = payload
        },
        SETWIDTH(state, payload){
            state.listwidth = payload
        },
        USERINFO(state, payload) {
            state.userMsg = payload
        },
        SEARCHINFO(state, payload) {
            state.searchdata = payload
        },
        SELECTFRIEND(state, payload) {
            state.selectfriend = payload
        },
        SELECTFRIENDINFO(state, payload) {
            state.selectfriend.friendinfo = payload
        },
        SELECTFRIENDDATA(state, payload) {
            state.selectfriend.wechatMessage = payload
        },
        SELECTCHAT(state, payload) {
            state.chatdata = payload
        },
        SETFRIEND(state, payload) {
            state.frienddata = payload
        },
        CHATSTATE(state, bool) {
            state.chatstate = bool
        },
        SOCKETSTATE(state, bool) {
            state.socketstate = bool
        },
        MSGID(state, payload) {
            state.msguuid = payload
        },
        RESETVUEX(state) {
            state = {
                userMsg: '', //user信息
                searchdata: { //搜索信息
                    data: []
                },
                selectfriend: {
                    wechatContactinfo: {
                        friendid: '',
                        wechatid: ''
                    }, //当前聊天好友信息
                    wechatMessage: {
                        lastmsgid: 0,
                        data: []
                    } //当前好友聊天记录信息
                },
                chatdata: {
                    records: []
                }, //会话列表
                frienddata: {}, //好友列表
                chatstate: true, //是否聊天状态 否=》查看记录状态
                socketstate: false, //websocket是否连接
                msguuid: '', //消息uuid
            }
        },

    },
    actions: {
       
    },
    getters: {
        currentUser: state => {
            return state.userMsg
        },
        searchlist: state => {
            return state.searchdata
        },
        selectfriendids: state => {
            return state.selectfriend
        },
        chatlist: state => {
            return state.chatdata
        },
        friendlist: state => {
            return state.frienddata
        },
        nowchatstate: state => {
            return state.chatstate
        },
        nowsocketstate: state => {
            return state.socketstate
        },
        newuuid: state => {
            return state.msguuid
        },
        getlistwidth:state => {
            return state.listwidth
        },
        getdocumentary:state => {
            return state.documentary
        },
        getdocumentarywidth:state => {
            return state.documentarywidth
        },
        getdocumentarybutton:state => {
            return state.documentarybutton
        },
        gettaleSkillGrounp: state => {
            return state.taleSkillGrounp
        },
        cansend: state => {
            return state.cansend
        },
        reddata: state => {
            return state.reddata
        },
        selTeam: state => {
            return state.activeTeam
        },
        teamarr: state => {
            return state.teamarr
        },
        rightbtn: state => {
            return state.rightbtn
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/im.js